import { type Theme } from './theme.types'
import { buildColors } from './theme.utils'

export const buildTheme = (theme: Theme) => {
  const variables = Object.entries(theme).map(([colorName, color]) => ([
    ...buildColors(colorName, color),
  ])).flat()
  return variables.join(' ')
}
